module.exports = __webpack_public_path__ + "static/media/spinner.c116c4fc.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/spinner.svg
 ** module id = 472
 ** module chunks = 0
 **/